import { Config } from '@leverege/plugin';
import OverlayedImage from "./OverlayedImage.js";
import S from './OverlayThumbnailRenderer.css';
import useOverlay from "./useOverlay.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function OverlayThumbnailRenderer(props) {
  const {
    item,
    src,
    showOverlays,
    path,
    context
  } = props;
  const {
    layers,
    loading
  } = useOverlay({
    item,
    src,
    path,
    exclude: Config.get('OverlayThumbnailRenderer', 'excludeLayers')
  });
  return /*#__PURE__*/_jsxs("div", {
    className: S.imageHolder,
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: S.loader,
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-spin fa-spinner fa-3x"
      })
    }), /*#__PURE__*/_jsx(OverlayedImage, {
      overlaysEnabled: showOverlays,
      src: src,
      layers: layers,
      context: context
    })]
  });
}